import { get } from "svelte/store";
import {
  BattleLogs,
  CraftStore,
  CurrentStateName,
  DecideStore,
  GameStatesStore,
  GameStateStore,
  Hearts,
  ItemsStore,
  MonsterStore,
  PlayerId,
  PotionsDiscardPile,
  PotionsStore,
  SelectedActions,
  SetupStore,
  SwitchMonster,
  UsablePotions,
  RogueCounter,
  AlchemistCounter,
  MerchantTokenPosition,
  Top3Potions,
  ItemsToPlace,
} from "./stores/gameStore";

// NOTIFICATION HOOKS ----------------------------------------

const selectPlayerboard = (notif) => {
  SetupStore.update((s) => ({ ...s, playerboards: notif.args }));
};
const possibleToCraft = (notif) => {
  CraftStore.set(notif.args);
};

const heartsUpdate = (notif) => {
  Hearts.set(notif.args);
};

const nextMonsterClass1 = (notif) => {
  let monster = notif.args;
  if (Array.isArray(monster)) {
    monster = monster[0];
  }
  MonsterStore.update((s) => ({ ...s, class1: monster }));
};
const nextMonsterClass2 = (notif) => {
  let monster = notif.args;
  if (Array.isArray(monster)) {
    monster = monster[0];
  }
  MonsterStore.update((s) => ({ ...s, class2: monster }));
};
const nextMonsterClass3 = (notif) => {
  let monster = notif.args;
  if (Array.isArray(monster)) {
    monster = monster[0];
  }
  MonsterStore.update((s) => ({ ...s, class3: monster }));
};

const monsterAmountClass1 = (notif) => {
  let amount = notif.args;
  if (Array.isArray(amount)) {
    amount = amount[0];
  }
  MonsterStore.update((s) => ({ ...s, class1_amount: amount }));
};
const monsterAmountClass2 = (notif) => {
  let amount = notif.args;
  if (Array.isArray(amount)) {
    amount = amount[0];
  }
  MonsterStore.update((s) => ({ ...s, class2_amount: amount }));
};
const monsterAmountClass3 = (notif) => {
  let amount = notif.args;
  if (Array.isArray(amount)) {
    amount = amount[0];
  }
  MonsterStore.update((s) => ({ ...s, class3_amount: amount }));
};

const moveItem = (notif) => {
  const newItems = notif.args;
  // console.log(get(ItemsStore));
  ItemsStore.update((_items) => ({ ..._items, ...newItems }));
  // console.log(get(ItemsStore));
};

const selectedAction = (notif) => {
  SelectedActions.update((s) => {
    const playerId = get(PlayerId);
    const i = s.findIndex((el) => el.playerId == playerId);
    if (i < 0) {
      s.push({ playerId, action: notif.args });
    } else {
      s[i].action = notif.args;
    }
    return s;
  });
};
const allActions = (notif) => {
  SelectedActions.update((s) => [...notif.args]);
};
const readyPlayers = (notif) => {
  SelectedActions.update((s) => {
    let playerId = get(PlayerId);
    const i = s.findIndex((el) => el.playerId == playerId);

    if (i === undefined) return notif.args;

    return notif.args.map((el) => {
      if (el.playerId !== playerId) return el;
      return { ...el, action: s[i].action || el.action };
    });
  });
};

const battleLog = (notif) => {
  BattleLogs.addLog(notif.args);
};


const switchMonster = (notif) => {
  SwitchMonster.update((s) => ({ ...s, unusedItems: notif.args.unusedItems }));
  // console.log(get(SwitchMonster));
};
const decideCraftMaterial = (notif) => {
  DecideStore.set(notif.args);
};
const potions = (notif) => {
  const args = Array.isArray(notif.args) ? notif.args : [notif.args];
    let spectator = false;
    let playerId = get(PlayerId);
    args.forEach((potion) => {
      if (potion.id === 'facedown' && potion.card_location === playerId) {
        spectator = true;
      }
    });
    if (spectator == false) {
      PotionsStore.set(notif.args);
    }
};
const potionsDiscardPile = (notif) => {
  PotionsDiscardPile.set(notif.args);
};
const usablePotions = (notif) => {
  UsablePotions.set(notif.args);
};
const rogueCounter = (notif) => {
  RogueCounter.set(notif.args);
};
const alchemistCounter = (notif) => {
  AlchemistCounter.set(notif.args);
};
const merchantToken = (notif) => {
  let itemId = notif.args;

  if (Array.isArray(itemId)) {
    itemId = itemId[0];
  }
  MerchantTokenPosition.set(itemId);
};
const top3Potions = (notif) => {
  Top3Potions.set(notif.args);
};

const itemsToPlace = (notif) => {
  ItemsToPlace.set(notif.args);
};

const triggerSound = (notif) => {
  playSound(notif.args);
  window.GAME.disableNextMoveSound();
};

// NOTIFICATION MAP ------------------

const notifFunctions = {
  selectPlayerboard,
  moveItem,
  selectedAction,
  readyPlayers,
  allActions,
  heartsUpdate,
  nextMonsterClass1,
  nextMonsterClass2,
  nextMonsterClass3,
  monsterAmountClass1,
  monsterAmountClass2,
  monsterAmountClass3,
  possibleToCraft,
  battleLog,
  switchMonster,
  decideCraftMaterial,
  potions,
  potionsDiscardPile,
  usablePotions,
  rogueCounter,
  alchemistCounter,
  merchantToken,
  top3Potions,
  itemsToPlace,
  triggerSound,
};

// BGA HOOKS------------------------------------------------

export const onNotification = (notif) => {
  // console.log("NOTIF:", notif.type, notif);
  notifFunctions[notif.type]?.(notif);
};

export const onEnteringState = (stateName, args) => {
  // console.log("ENTERING", stateName, args);
  const curr = get(CurrentStateName);

  if (stateName === "fight" && curr !== "fight") {
    BattleLogs.reset();
  }
  if (stateName === "startFight" && curr !== "startFight") {
    SwitchMonster.set({
      unusedItems: {
        I1_7: true,
        I2_6: true,
      },
    });
  }
  CurrentStateName.set(stateName);
  GameStateStore.set(args);
};
export const onLeavingState = (stateName) => {
  // console.log("LEAVING", stateName);
};
